import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(message) {
        this.m48_1 = message;
        this.n48_1 = null;
        this.o48_1 = null;
        this.p48_1 = null;
        this.q48_1 = null;
      }
      r48(locations) {
        // Inline function 'kotlin.apply' call
        this.n48_1 = locations;
        return this;
      }
      s48(path) {
        // Inline function 'kotlin.apply' call
        this.o48_1 = path;
        return this;
      }
      f43(extensions) {
        // Inline function 'kotlin.apply' call
        this.q48_1 = extensions;
        return this;
      }
      t48(nonStandardFields) {
        // Inline function 'kotlin.apply' call
        this.p48_1 = nonStandardFields;
        return this;
      }
      v39() {
        return new (Error_0())(this.m48_1, this.n48_1, this.o48_1, this.q48_1, this.p48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocationClass;
function Location() {
  if (LocationClass === VOID) {
    class $ {
      constructor(line, column) {
        this.u48_1 = line;
        this.v48_1 = column;
      }
      toString() {
        return 'Location(line = ' + this.u48_1 + ', column = ' + this.v48_1 + ')';
      }
    }
    initMetadataForClass($, 'Location');
    LocationClass = $;
  }
  return LocationClass;
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ {
      constructor(message, locations, path, extensions, nonStandardFields) {
        this.w48_1 = message;
        this.x48_1 = locations;
        this.y48_1 = path;
        this.z48_1 = extensions;
        this.a49_1 = nonStandardFields;
      }
      toString() {
        return 'Error(message = ' + this.w48_1 + ', locations = ' + toString(this.x48_1) + ', path=' + toString(this.y48_1) + ', extensions = ' + toString(this.z48_1) + ', nonStandardFields = ' + toString(this.a49_1) + ')';
      }
    }
    initMetadataForClass($, 'Error');
    ErrorClass = $;
  }
  return ErrorClass;
}
//region block: exports
export {
  Builder as Builder3gaff1pwujyid,
  Location as Location25t453jk43ktl,
};
//endregion

//# sourceMappingURL=Error.mjs.map
